// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceAssetResource extends Resource {
    basePath: string = 'services/service-asset/';

    objectPath: string = 'services/service-asset/{ident}/';
}
